import { render, staticRenderFns } from "./status-tag.vue?vue&type=template&id=736238ac"
import script from "./status-tag.vue?vue&type=script&lang=js"
export * from "./status-tag.vue?vue&type=script&lang=js"
import style0 from "./status-tag.vue?vue&type=style&index=0&id=736238ac&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports